import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('callback-form', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./callback-form')
    ),
);
